import React from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import './NavbarStyles.css'; // Import a separate CSS file for styling

function TesterBudNavbar() {
    return (
        <Navbar expand="lg" variant="dark" style={{ backgroundColor: '#1e40af' }} sticky="top">
            <Container fluid>
                <Navbar.Brand href="/" className="fw-bold fs-2 text-white">
                    TesterBud
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="testerbud-navbar" />

                <Navbar.Collapse id="testerbud-navbar">
                    <Nav className="me-auto nav-spaced"> {/* Apply the spacing class */}
                        
                        <Nav.Link href="/practice-page-selection" className="text-white nav-item-bordered">Features</Nav.Link>

                        <NavDropdown
                            title={
                                <span className="text-white nav-item-bordered">
                                    Practice Sites
                                </span>
                            }
                            id="practice-sites-dropdown"
                            menuVariant="dark"
                            
                        >
                            <NavDropdown.Item href="/practice-login-form" className="dropdown-modern-item">🔐 Login Automation</NavDropdown.Item>
                            <NavDropdown.Item href="/practice-forms" className="dropdown-modern-item">📋 Web Form Automation</NavDropdown.Item>
                            <NavDropdown.Item href="/forget-password" className="dropdown-modern-item">🔑 Forget Password Page</NavDropdown.Item>
                            <NavDropdown.Item href="/register" className="dropdown-modern-item">📝 Registration Form</NavDropdown.Item>
                            
                            <NavDropdown.Item href="/practice-ecommerece-website" className="dropdown-modern-item">🛒 E-commerce Testing</NavDropdown.Item>
                            <NavDropdown.Item href="/flight-booking-scenarios" className="dropdown-modern-item">✈️ Flight Booking Practice</NavDropdown.Item>
                            <NavDropdown.Item href="/practice-different-ui-elements" className="dropdown-modern-item">🎛️ UI Element Automation</NavDropdown.Item>
                            <NavDropdown.Item href="/SeleniumXPathGuide" className="dropdown-modern-item">🧭 XPath Practicem for Selenium</NavDropdown.Item>
                            
                        </NavDropdown>


                      
                        <Nav.Link href="/AboutPage" className="text-white nav-item-bordered">About</Nav.Link>
                       
                    </Nav>

                    
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default TesterBudNavbar;